import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { createCommentInPost } from '../../../../features/sessions/sessionPostProject/sessionPostProject';
import { toast } from 'react-toastify';
import { Box, Button, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const BG_CARD        = '#24242e';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';

const inputSx = {
    flex: 1,
    '& .MuiOutlinedInput-root': {
        color: TEXT_PRIMARY,
        bgcolor: BG_CARD,
        '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
        '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },

        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitBoxShadow: `0 0 0 100px #1c1c24 inset`,
            WebkitTextFillColor: '#f4f4f6',
            caretColor: '#f4f4f6',
        },
        '&.Mui-focused fieldset': { borderColor: 'rgba(255,255,255,0.7)' },
    },
    '& textarea': { color: TEXT_PRIMARY },
};

export default function CreateCommentInPostForm({ postId }: { postId: string }) {
    const [inputComment, setInputComment] = useState<string>('');
    const authHeaders = useSelector((state: RootState) => state.session.authHeaders);
    const currentUser = useSelector((state: RootState) => state.session.currentUser);
    const dispatch    = useDispatch<AppDispatch>();

    async function handleCommentPost() {
        if (authHeaders && currentUser && currentUser.nickname) {
            const response = await dispatch(
                createCommentInPost({
                    authHeaders: authHeaders,
                    createCommentInPostRouteParams: {
                        userNickname: currentUser.nickname,
                        postId: postId,
                    },
                    body: {
                        postId: postId,
                        body: inputComment,
                    },
                })
            );

            if (response.meta.requestStatus === 'fulfilled') {
                setInputComment('');
            }

            if (response.payload.errors && response.payload.errors.length > 0) {
                response.payload.errors.map((item: string) => { toast.error(item); });
            }
        }
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
            <TextField
                fullWidth
                multiline
                maxRows={3}
                size='small'
                placeholder='Write a comment...'
                value={inputComment}
                onChange={(e) => setInputComment(e.target.value)}
                inputProps={{ maxLength: 500 }}
                sx={inputSx}
            />
            <Button
                variant='contained'
                size='small'
                onClick={handleCommentPost}
                endIcon={<SendIcon sx={{ fontSize: '15px !important' }} />}
                sx={{
                    bgcolor: BRAND_RED,
                    textTransform: 'none',
                    fontWeight: 600,
                    flexShrink: 0,
                    alignSelf: 'flex-end',
                    '&:hover': { bgcolor: '#a93226' },
                }}
            >
                Comment
            </Button>
        </Box>
    );
}
